/** @format */

import { _1 } from './1'
import { _2 } from './2'
import { _3 } from './3'
import { _4 } from './4'
import { _5 } from './5'
import { _6 } from './6'
import { _7 } from './7'
import { _8 } from './8'
import { _9 } from './9'
import { _10 } from './10'
import { _11 } from './11'
import { _12 } from './12'
import { _13 } from './13'

const obj = {
  _1,
  _2,
  _3,
  _4,
  _5,
  _6,
  _7,
  _8,
  _9,
  _10,
  _11,
  _12,
  _13,
}

export default obj
